import React, { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import OnboardingModal from "@/components/OnboardingModal";
import AnnouncementModal from "@/components/AnnouncementModal";
import RenameWarningModal from "@/components/RenameWarningModal";
import AmbientBackground from "@/components/AmbientBackground";
import Auth from "@/pages/Auth";
import Matches from "@/pages/Matches";
import Leaderboard from "@/pages/Leaderboard";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import Bonus from "@/pages/Bonus";
import Notifications from "@/pages/Notifications";

function Protected({ children, adminOnly }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-white/40 text-xs tracking-widest uppercase">Loading…</div>;
  if (!user) return <Navigate to="/" replace />;
  if (adminOnly && !user.is_admin) return <Navigate to="/matches" replace />;
  return children;
}

function OnboardingGate() {
  const { user } = useAuth();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!user) return;
    try {
      const flag = localStorage.getItem(`mm_onboarded_${user.id}`);
      const showRequested = sessionStorage.getItem("mm_show_onboarding");
      if (!flag || showRequested === "1") {
        setShow(true);
        sessionStorage.removeItem("mm_show_onboarding");
      }
    } catch (e) {
      // ignore
    }
  }, [user]);

  const close = () => {
    setShow(false);
    if (user) {
      try { localStorage.setItem(`mm_onboarded_${user.id}`, "1"); } catch (e) { /* ignore */ }
    }
  };

  return <OnboardingModal open={show} onClose={close} />;
}

function App() {
  return (
    <div className="App grain min-h-screen text-white relative">
      <AmbientBackground />
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Auth />} />
              <Route path="/matches" element={<Protected><Matches/></Protected>} />
              <Route path="/bonus" element={<Protected><Bonus/></Protected>} />
              <Route path="/notifications" element={<Protected><Notifications/></Protected>} />
              <Route path="/leaderboard" element={<Protected><Leaderboard/></Protected>} />
              <Route path="/profile" element={<Protected><Profile/></Protected>} />
              <Route path="/admin" element={<Protected adminOnly><Admin/></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <OnboardingGate />
            <RenameWarningModal />
            <AnnouncementModal />
          </BrowserRouter>
          <Toaster theme="dark" position="top-center" toastOptions={{
            style: { background: "#1A0A24", border: "1px solid rgba(232,180,240,0.2)", color: "#fff" }
          }} />
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
